import { render, staticRenderFns } from "./TherapyStepper.vue?vue&type=template&id=0fc56a79&scoped=true&"
import script from "./TherapyStepper.vue?vue&type=script&lang=js&"
export * from "./TherapyStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc56a79",
  null
  
)

export default component.exports